module.exports = __webpack_public_path__ + "f5fe308bec98d9a51f580fc4542efe49.jpg";